module.exports = __webpack_public_path__ + "fonts/iconfont.8e204da0.woff2";